import { create } from 'zustand';
import type { AgencyBrand } from '../types';

/** ADR-0041: the header that tells the server which agency a Gromly admin has entered. */
export const ACTING_AGENCY_HEADER = 'X-Gromly-Agency';

const KEY = 'gromly.actingAgency';

/** Per tab: closing it is leaving the agency. */
function read(): AgencyBrand | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) as AgencyBrand : null;
  } catch {
    return null;
  }
}

function write(agency: AgencyBrand | null) {
  try {
    if (agency) sessionStorage.setItem(KEY, JSON.stringify(agency)); else sessionStorage.removeItem(KEY);
  } catch { /* lasts until reload */ }
}

interface ActingAgencyState {
  /** The agency a Gromly admin is inside, as the agency (ADR-0041). The server checks `isAdmin` on every call. */
  agency: AgencyBrand | null;
  enter: (agency: AgencyBrand) => void;
  leave: () => void;
}

// Apart from agencies.store: api/client.ts reads it, and agencies.store imports the API.
export const useActingAgency = create<ActingAgencyState>(set => ({
  agency: read(),
  enter: agency => { write(agency); set({ agency }); },
  leave: () => { write(null); set({ agency: null }); },
}));
